export default __webpack_public_path__ + "static/media/pomodoro.3ef794a7.png";